import { CardWrapper } from '@monorepo/common';
import { Typography } from '@mui/material';

export const PrepaidListingExpired = () => (
  <CardWrapper>
    <Typography
      variant="h4"
      marginBottom={4}
      textAlign="center"
    >
      Your prepaid listings package has expired.
    </Typography>
  </CardWrapper>
);
